/**
 
 @Name: layuiNetCompany - 大气风格的网络公司企业模版
 @Author: xuxingyu
 @Copyright: layui.com
 
 */

layui.define(['jquery', 'element', 'carousel', 'laypage','flow','layer'], function(exports){
  var $ = layui.jquery
  ,element = layui.element
  ,carousel = layui.carousel
  ,laypage = layui.laypage
  ,flow = layui.flow;
  var options = {
        useEasing : true, 
        useGrouping : true, 
        separator : ',', 
        decimal : '.', 
        prefix : '', 
        suffix : '' 
      };
  // var demo = new CountUp("myTargetElement", 0, 5, 0, 1, options);
  // var demo2 = new CountUp("myTargetElement2", 0, 100, 0, 1, options);
  // var demo3 = new CountUp("myTargetElement3", 0, 30, 0, 1, options);
  // demo.start();
  // demo2.start();
  // demo3.start();

  var img_index = 0;
  var img_src = "";
  
  $("#addWeChat").click(function() {
    layer.open({
      type: 1
      ,title: false //不显示标题栏
      ,closeBtn: false
      ,area: '300px;'
      ,shade: 0.8
      ,shadeClose: true
      ,id: 'LAY_layuipro' //设定一个id，防止重复弹出
      ,moveType: 1 //拖拽模式，0或者1
      ,skin: 'weChat-class'
      ,content: '<img src="../img/code-H.png" style="width: 150px;height: 150px">'
    });
  })


$.fn.longPress = function (fn) {
  　　let timer = null;
  　　let $this = this;
  　　for (let i = 0; i < $this.length; i++) {
    
    　　$this[i].addEventListener('touchstart', function (event) {
    　　		timer = setTimeout(fn, 600);
    　　}, false);
    
    　　$this[i].addEventListener('touchend', function (event) {
    　　		clearTimeout(timer);
    　　}, false);
  　　}
  }


	$(function() {
		//计算居中位置
		var mg_top = ((parseInt($(window).height()) - parseInt($(".photo-div").height())) / 2);

		
		//关闭
		$(".photo-close").click(function() {
			$(".photo-mask").hide();
			$(".photo-panel").hide();
		});
		//下一张
		$(".photo-panel .photo-div .arrow-next").click(function() {
			img_index++;
			if(img_index >= $(".photo-list .case-list-img img").length) {
				img_index = 0;
			}
			img_src = $(".photo-list .case-list-img img").eq(img_index).attr("src");
			photoView($(".photo-list .case-list-img img"));
		});
		//上一张
		$(".photo-panel .photo-div .arrow-prv").click(function() {
			img_index--;
			if(img_index < 0) {
				img_index = $(".photo-list .case-list-img img").length - 1;
			}
			img_src = $(".photo-list .case-list-img img").eq(img_index).attr("src");
			photoView($(".photo-list .case-list-img img"));
		});
		//如何调用？
		$(".photo-list .case-list-img .photos-fade").click(function() {
			$(".photo-mask").show();
      $(".photo-panel").show();
      
      console.log($(this).next().attr("src"));
			img_src = $(this).next().attr("src");
			img_index = $(this).index();
			photoView($(this));
    });
    
    //自适应预览
	function photoView(obj) {
		if($(obj).width() >= $(obj).height()) {
			$(".photo-panel .photo-div .photo-img .photo-view-h").attr("class", "photo-view-w");
			$(".photo-panel .photo-div .photo-img .photo-view-w img").attr("src", img_src);
		} else {
			$(".photo-panel .photo-div .photo-img .photo-view-w").attr("class", "photo-view-h");
			$(".photo-panel .photo-div .photo-img .photo-view-h img").attr("src", img_src);
		}
		//此处写调试日志
		console.log(img_index);
	}

  });
  

  //轮播渲染
  carousel.render({
    elem: '#banner'
    ,width: '100%'
    ,height: $(window).height()
    ,arrow: 'always'
  });
  carousel.render({
    elem: '#banner-p'
    ,width: '100%'
    ,height: $(window).height()
    ,arrow: 'always'
  });

  // layer.photos({
  //   photos: '#layer-photos-demo'
  //   ,anim: 5 //0-6的选择，指定弹出图片动画类型，默认随机（请注意，3.0之前的版本用shift参数）
  //   ,tab:function(pic,layero){
  //     console.log(pic,layero)
  //   }
  // });

  //软件开发数据
  var codeData=[
    {imgurl:'./img/home/case-list-1.png',title:'案场分析',text:'应用于二次到店分析需求的场景，应用地产、售楼部、4S店等场景'},
    {imgurl:'./img/home/case-list-1.png',title:'人员去向牌管理系统',text:'人员去向牌管理系统专为政府机关和事业单位等机构打造的办公后台软件系统'},
    {imgurl:'./img/home/case-list-1.png',title:'宿舍公寓人脸识别系统',text:'实时查看学生在寝、外出、陌生人等统计信息'},
    {imgurl:'./img/home/case-list-1.png',title:'智慧公寓管理系统',text:'根据学校实际情况和需求定制化开发管理平台，保证最大限度的适合校方使用需求'},
    {imgurl:'./img/home/case-list-1.png',title:'Fun++',text:'资源共享对等置换'},
    {imgurl:'./img/home/case-list-1.png',title:'商丘学院',text:'使用人脸识别抓拍，实时查看学生在寝情况'},
    {imgurl:'./img/home/case-list-1.png',title:'慧构鹰眼管理平台',text:'疫情防控测温系统'},
    {imgurl:'./img/home/case-list-1.png',title:'生物识别特征库',text:'人员信息人脸、指纹解决方案'},
    {imgurl:'./img/home/case-list-1.png',title:'智慧公寓微信公众号',text:'实时消息推送，学生安全不担心'},
  ]
  //高校案例数据
  var schoolData;
  //园区地产数据
  var real;

  //流加载
  flow.load({
    elem: '#LAY_demo2' //流加载容器
    ,scrollElem: '#LAY_demo2' //滚动条所在元素，一般不用填，此处只是演示需要。
    ,isAuto: false
    ,isLazyimg: true
    ,done: function(page, next){ //加载下一页
      //模拟插入
      setTimeout(function(){
        var lis = [];
        // for(var i = 0; i < 6; i++){
        //   lis.push("<div class='layui-col-md4'>" +
        //    "<div class='case-list-content'>" +
        //    "<div class='case-list-img'>" +
        //    "<img src='./img/home/case-list-1.png' alt=''>" +
        //    "</div>" +
        //    "<div class='case-list-title'>" +
        //    "<h1>北京科技大学</h1>" +
        //    "<hr>" +
        //    "<p>宿舍公寓一体化人脸闸机解决方案全案</p>" +
        //    "</div>" +
        //    "</div>" +
        //    "</div>")
        // }
        next(lis.join(''), page < 1); //假设总页数为 6
      }, 500);
    }
  });
  flow.load({
    elem: '#LAY_demo3' //流加载容器
    ,scrollElem: '#LAY_demo2' //滚动条所在元素，一般不用填，此处只是演示需要。
    ,isAuto: false
    ,isLazyimg: true
    ,done: function(page, next){ //加载下一页
      //模拟插入
      setTimeout(function(){
        var lis = [];
        // for(var i = 0; i < 6; i++){
        //   lis.push("<div class='layui-col-md4'>" +
        //    "<div class='case-list-content'>" +
        //    "<div class='case-list-img'>" +
        //    "<img src='./img/home/case-list-3.png' alt=''>" +
        //    "</div>" +
        //    "<div class='case-list-title'>" +
        //    "<h1>北京科技大学</h1>" +
        //    "<hr>" +
        //    "<p>宿舍公寓一体化人脸闸机解决方案全案</p>" +
        //    "</div>" +
        //    "</div>" +
        //    "</div>")
        // }
        next(lis.join(''), page < 1); //假设总页数为 6
      }, 500);
    }
  });
  flow.load({
    elem: '#LAY_demo1' //流加载容器
    ,scrollElem: '#LAY_demo2' //滚动条所在元素，一般不用填，此处只是演示需要。
    ,isAuto: false
    ,isLazyimg: true
    ,done: function(page, next){ //加载下一页
      //模拟插入
      setTimeout(function(){
        var lis = [];
        // for(var i = 0; i < 6; i++){
        //   lis.push("<div class='layui-col-md4'>" +
        //    "<div class='case-list-content'>" +
        //    "<div class='case-list-img'>" +
        //    "<img src='./img/home/case-list-2.png' alt=''>" +
        //    "</div>" +
        //    "<div class='case-list-title'>" +
        //    "<h1>北京科技大学</h1>" +
        //    "<hr>" +
        //    "<p>宿舍公寓一体化人脸闸机解决方案全案</p>" +
        //    "</div>" +
        //    "</div>" +
        //    "</div>")
        // }
        next(lis.join(''), page < 1); //假设总页数为 6
      }, 500);
    }
  });

  //监听窗口大小
  $(window).resize(function() {
    $("#banner").css("height",$(window).height());
    if($(window).width() <= 768) {
      $(".banner").css("height",$(window).height());
    }
  });

  //滚动监听
  $(window).scroll(function() {
    var scr=$(document).scrollTop();
    scr > 0 ? $(".nav").addClass('scroll') : $(".nav").removeClass('scroll');
  });



  
  $(function(){
    if($(window).width() <= 768) {
      $(".banner").css("height",$(window).height());
    }
    //轮播文字
    $('.banner').children('.title').addClass('active');
    //初始加载判断高度
    if($(document).scrollTop() > 0) {
      $(".nav").addClass('scroll')
    }else {
      $(".nav").removeClass('scroll')
    }
  })

  //导航切换
  var btn = $('.nav').find('.nav-list').children('button')
  ,spa = btn.children('span')
  ,ul = $('.nav').find('.nav-list').children('.layui-nav');
  btn.on('click', function(){
    
    if(!$(spa[0]).hasClass('spa1')){
      /* 添加样式 yilingsj 20200518 start */
      $(".nav.index").css("background", "#0076ff").addClass('isMobileNavShow');
      /* 添加样式 yilingsj 20200518 end */
      spa[0].className = 'spa1';
      spa[1].style.display = 'none';
      spa[2].className = 'spa3';
      $('.nav')[0].style.height = 90 + ul[0].offsetHeight + 'px';
    }else{
      /* 移除样式 yilingsj 20200518 start */
      $(".nav.index").css("background", "transparent").removeClass('isMobileNavShow');
      /* 移除样式 yilingsj 20200518 end */
      spa[0].className = '';
      spa[1].style.display = 'block';
      spa[2].className = '';
      $('.nav')[0].style.height = 80 + 'px';
    }
  });

  $('.icon-qq').hover(
    function(){ 
      $('.icon-qq-hove-content').css('visibility','visible')
    }, function() {
      $('.icon-qq-hove-content').css('visibility','hidden')
    }
  )
  $('.icon-chat').hover(
    function(){ 
      $('.icon-chat-hove-content').css('visibility','visible')
    }, function() {
      $('.icon-chat-hove-content').css('visibility','hidden')
    }
  )

  //关于内容
  $('.main-about').find('.aboutab').children('li').each(function(index){
    $(this).on('click', function(){
      $(this).addClass('layui-this').siblings().removeClass('layui-this');
      $('.aboutab').siblings().fadeOut("fast");
      $('.aboutab').siblings().eq(index).fadeIn("");
    });
  });

  //动态分页
  laypage.render({
    elem: 'newsPage'
    ,count: 50
    ,theme: '#2db5a3'
    ,layout: ['page', 'next']
  });

  //案例分页
  laypage.render({
    elem: 'casePage'
    ,count: 50
    ,theme: '#2db5a3' 
    ,layout: ['page', 'next']
  });

  //新闻字段截取
  $(function(){
    $(".main-news").find(".content").each(function(){
      var span = $(this).find(".detail").children("span")
      ,spanTxt = span.html();
      if(document.body.clientWidth > 463){
        span.html(spanTxt);
      }else{
        span.html(span.html().substring(0, 42)+ '...')
      };
      $(window).resize(function(){   
        if(document.body.clientWidth > 463){
          span.html(spanTxt);
        }else{
          span.html(span.html().substring(0, 42)+ '...')
        };
      });
    });
  });  

  exports('firm', {}); 
});